import React from 'react';
import moment from 'moment';
import { TRANSACTIONS_TYPE } from '../../../../utils/constants/insights-filter';

const SourcesTable = ({
    rows,
    columns,
    paginationData,
    paginationState,
    setPaginationState,
}: {
    rows?: any;
    columns?: any;
    paginationData?: any;
    paginationState?: any;
    setPaginationState?: any
}) => {

    const formatText = (text: string | null | undefined): string => {
        if (!text) return '';

        return text
            .toLowerCase()
            .split(' ')
            .map(word =>
                word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(' ');
    };

    const formatType = (coming: string) => {
        return <div className={`px-3 py-1 text-center rounded-md ${(coming || '')?.toLowerCase() === 'psp' ? 'bg-[#FAFAFA] dark:bg-[#1f1f1f]' : 'bg-[#414651] text-white'}`}>
            {(coming || '').toUpperCase()}
        </div>
    }

    return (
        <div className=''>
            <div className='overflow-x-auto max-h-[520px] overflow-y-auto border border-1 !rounded-xl dark:border-borderColor-darkMode'>
                <table className='min-w-full bg-white dark:bg-black dark:text-primary-dark'>
                    <thead className='bg-white dark:bg-black text-left text-sm font-medium text-black dark:text-primary-dark rounded-xl'>
                        <tr>

                            {columns && columns?.length > 0 && columns?.map((item: any, idx: number) => {
                                return (
                                    <th key={idx} className='px-4 py-3'>{item?.name}</th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row: any) => (
                            <tr key={row.id} className='hover:bg-gray-50 dark:hover:bg-bgColor-darkMode text-sm'>
                                {columns && columns?.length > 0 && columns?.map((item: any, idx: number) => {
                                    if (item?.key === 'type') {
                                        return (
                                            <td key={idx} className={`px-4 py-4`}>
                                                {formatType(row?.[item?.key])}
                                            </td>
                                        )
                                    }
                                    if (item?.key === 'status') {
                                        return (
                                            <td key={idx} className={`px-4 py-4`}>{formatText(row?.[item?.key])}</td>
                                        )
                                    }
                                    if (item?.key === 'createdAt') {
                                        return (
                                            <td key={idx} className={`px-4 py-4`}>{moment(row?.createdAt).format('DD-MM-YYYY, hh:mm A')}</td>
                                        )
                                    }
                                    if (item?.key === 'type') {
                                        const findTransaction = row?.[item?.key] ? TRANSACTIONS_TYPE?.find((transaction: any) => transaction?.value === row?.[item?.key])?.label : row?.[item?.key]
                                        return (
                                            <td key={idx} className={`px-4 py-4`}>{findTransaction}</td>
                                        )
                                    }
                                    else {
                                        return (
                                            <td key={idx} className={`px-4 py-4 ${['dateTime', 'dateAnalyzed']?.includes(item?.key) ? 'min-w-[120px]' : ''} ${item?.key === 'description' ? 'text-primary-light' : ''}`}>{['amountPOS', 'amountPSP']?.includes(item?.key) ? '€' : ''}{row?.[item?.key] || '--'}</td>
                                        )
                                    }
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SourcesTable;
